import React from "react";
import "../assets/css/fontawesome.css";
import "../assets/css/slick.css";
import "../assets/css/lightgallery.min.css";
import "../assets/css/animate.css";
import "../assets/css/style.css";
import {
  MDBCol,
  MDBContainer,
  MDBIcon,
  MDBRow,
  MDBTypography,
} from "mdb-react-ui-kit";
import hammedimage from "../assets/img/client/hammed.jpeg";
import jerryimage from "../assets/img/client/jerry.jpeg";

const Review = () => {
  return (
    <>
      <MDBContainer className="py-5">
        <MDBRow className="d-flex justify-content-center">
          <MDBCol md="10" xl="8" className="text-center">
            <h3 className="mb-4">Testimonials</h3>
            <p className="mb-4 pb-2 mb-md-5 pb-md-0">
              Testimonials serve as a testament to the quality and reliability
              of our products/services. They provide reassurance to potential
              customers, giving them the confidence to choose our company.
              Feedback allows us to better understand needs and preferences,
              enabling us to continually improve and deliver tailor-made
              solutions.
            </p>
          </MDBCol>
        </MDBRow>
        <MDBRow className="text-center">
          <MDBCol md="4" className="mb-5 mb-md-0">
            <div className="d-flex justify-content-center mb-4">
              <img
                src="https://avatars.githubusercontent.com/u/125818961?v=4"
                className="rounded-circle shadow-1-strong"
                width="150"
                height="150"
                alt="Ogundiran Victor "
              />
            </div>
            <h5 className="mb-3">Ogundiran Victor</h5>
            <h6 className="text-primary mb-3">Senior Software Developer</h6>
            <p className="px-xl-3">
              <MDBIcon fas icon="quote-left" className="pe-2" />
              Vicky Dev a software developer from SQI College of ICT. In my
              observation, Dev Vicky exhibits impressive technical skills and a
              strong understanding of full stack development. He demonstrates a
              keen ability to work on both front-end and back-end technologies,
              making him a valuable asset for any software development team.
              <MDBIcon fas icon="quote-right" className="pe-2" />
            </p>
            <MDBTypography
              listUnStyled
              className="d-flex justify-content-center mb-0"
            >
              <li>
                <MDBIcon fas icon="star" size="sm" className="text-warning" />
              </li>
              <li>
                <MDBIcon fas icon="star" size="sm" className="text-warning" />
              </li>
              <li>
                <MDBIcon fas icon="star" size="sm" className="text-warning" />
              </li>
              <li>
                <MDBIcon
                  fas
                  icon="star-half"
                  size="sm"
                  className="text-warning"
                />
              </li>
            </MDBTypography>
          </MDBCol>
          <MDBCol md="4" className="mb-5 mb-md-0">
            <div className="d-flex justify-content-center mb-4">
              <img
                src={hammedimage}
                className="rounded-circle shadow-1-strong"
                width="150"
                height="150"
                alt="Hammed Tunde Olatunji"
              />
            </div>
            <h5 className="mb-3">Hammed Tunde Olatunji</h5>
            <h6 className="text-primary mb-3">
              Snr. Software Engineer at AluSoft Technologies Limited
            </h6>
            <p className="px-xl-3">
              <MDBIcon fas icon="quote-left" className="pe-2" />
              {/* Your Review here */}
              I highly recommend Adebanjo Favour as an software developer. He
              consistently demonstrated strong problem-solving skills, a quick
              grasp of new concepts, and a dedicated work ethic. His
              contributions significantly enhanced our team's productivity
              during his internship at AluSoft
              <MDBIcon fas icon="quote-right" className="pe-2" />
            </p>
            <MDBTypography
              listUnStyled
              className="d-flex justify-content-center mb-0"
            >
              <li>
                <MDBIcon fas icon="star" size="sm" className="text-warning" />
              </li>
              <li>
                <MDBIcon fas icon="star" size="sm" className="text-warning" />
              </li>
              <li>
                <MDBIcon fas icon="star" size="sm" className="text-warning" />
              </li>
              <li>
                <MDBIcon fas icon="star" size="sm" className="text-warning" />
              </li>
              <li>
                <MDBIcon fas icon="star" size="sm" className="text-warning" />
              </li>
            </MDBTypography>
          </MDBCol>
          <MDBCol md="4" className="mb-5 mb-md-0">
            <div className="d-flex justify-content-center mb-4">
              <img
                src={jerryimage}
                className="rounded-circle shadow-1-strong"
                width="150"
                height="150"
                alt="Jeremiah Joseph"
              />
            </div>
            <h5 className="mb-3">Jeremiah Joseph</h5>
            <h6 className="text-primary mb-3">
              Creative Brand Strategist & Designer at AluSoft Technologies
              Limited
            </h6>
            <p className="px-xl-3">
              <MDBIcon fas icon="quote-left" className="pe-2" />
              {/* <br> */}
              Favour, A software developer showcases exceptional technical
              abilities and a profound comprehension of full stack development.
              Through my observation, I have noticed that Favour possesses a
              remarkable aptitude for working with various front-end and
              back-end technologies, which undoubtedly positions him as a highly
              valuable resource for any software development team.
              <MDBIcon fas icon="quote-right" className="pe-2" />
            </p>
            <MDBTypography
              listUnStyled
              className="d-flex justify-content-center mb-0"
            >
              <li>
                <MDBIcon fas icon="star" size="sm" className="text-warning" />
              </li>
              <li>
                <MDBIcon fas icon="star" size="sm" className="text-warning" />
              </li>
              <li>
                <MDBIcon fas icon="star" size="sm" className="text-warning" />
              </li>
              <li>
                <MDBIcon fas icon="star" size="sm" className="text-warning" />
              </li>
              <li>
                <MDBIcon far icon="star" size="sm" className="text-warning" />
              </li>
            </MDBTypography>
          </MDBCol>
        </MDBRow>
      </MDBContainer>
    </>
  );
};
export default Review;
